/*
 * <tittli-countdown> — "sale ends in" clock.
 *
 * The element carries two epochs from Liquid: when the sale ends and what the
 * server's clock read as the page was built. The remaining time is the gap
 * between them, ticked down with the browser's own elapsed time rather than
 * its wall clock, so a device set to the wrong date still shows the right
 * number, and a reload picks up where the last one left off instead of
 * starting over.
 *
 * At zero it rolls forward one window rather than sitting at 00:00:00, which
 * is what the next page load would have shown anyway.
 */
class TittliCountdown extends HTMLElement {
  connectedCallback() {
    const ends = Number(this.dataset.ends);
    const servedAt = Number(this.dataset.now);
    if (!ends || !servedAt) return;

    this.hours = this.querySelector('[data-countdown-hours]');
    this.minutes = this.querySelector('[data-countdown-minutes]');
    this.seconds = this.querySelector('[data-countdown-seconds]');
    if (!this.hours || !this.minutes || !this.seconds) return;

    this.window = Number(this.dataset.window) || 6 * 3600;
    this.remaining = ends - servedAt;
    this.openedAt = performance.now();

    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  tick() {
    const elapsed = Math.floor((performance.now() - this.openedAt) / 1000);
    let left = this.remaining - elapsed;

    /* Rolling by a whole window keeps it on the same boundary the server
     * would have picked. */
    while (left <= 0) left += this.window;

    const pad = (n) => String(n).padStart(2, '0');
    this.hours.textContent = pad(Math.floor(left / 3600));
    this.minutes.textContent = pad(Math.floor((left % 3600) / 60));
    this.seconds.textContent = pad(left % 60);
  }
}

if (!customElements.get('tittli-countdown')) {
  customElements.define('tittli-countdown', TittliCountdown);
}
